export default __webpack_public_path__ + "static/media/CNo.62-3.e424dac8.jpg";